import { useState } from "react";
import { useNavigate } from "react-router-dom";
import QueryParameters from "../api/QueryParameters";
import { sendPreferencesRequest } from "../api/requests";
import { Preferences } from "../common/GeneralClasses";
import { buildThankYouUrl } from "../views/ThankYou";
import Button from "./Button";

interface PreferenceButtonProps {
  buttonLabel: string;
  thankYouLabel: string;
  errorMessage: string;
  confirmButtonLabel: string;
  confirmButtonUrl: string;
  preferences: Preferences[];
}

export default function PreferenceButton(props: PreferenceButtonProps) {
  const navigate = useNavigate();

  const [isLoading, setLoading] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);

  const onClickHandler = () => {
    const queryParams = new QueryParameters();
    setShowErrorMessage(false);
    setLoading(true);

    sendPreferencesRequest(queryParams, props.preferences)
      .then((status) => {
        if (status) {
          navigate(buildThankYouUrl(queryParams), {
            state: {
              label: props.thankYouLabel,
              buttonLabel: props.confirmButtonLabel,
              buttonUrl: props.confirmButtonUrl
            }
          });
        } else {
          setShowErrorMessage(true);
        }
      })
      .catch(() => {
        setShowErrorMessage(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Button
      buttonLabel={props.buttonLabel}
      errorMessage={props.errorMessage}
      onClick={onClickHandler}
      isLoading={isLoading}
      showErrorMessage={showErrorMessage}
    />
  );
}
